import React, { useState, useEffect } from 'react';
// // import { useTranslation } from 'react-i18next';
  // Admin은 다국어 지원 불필요// Admin은 다국어 지원 불필요import { motion, AnimatePresence } from 'framer-motion';
import {
  MessageSquare, Users, Clock, CheckCircle, XCircle, Search, Filter, RefreshCw, Eye, Edit, Trash2, Send
} from 'lucide-react';
import { db, appId } from '../firebase/firebaseConfig.jsx';
import {
  collection, query, orderBy, limit, getDocs, doc, updateDoc, deleteDoc, where, startAfter, getCountFromServer
} from 'firebase/firestore';
import { useToastMessage } from '../contexts/ToastMessageContext.jsx';

const AdminConsultationDashboard = () => {
  // const { t } = useTranslation();
   // Admin은 다국어 지원 불필요const { showToastMessage } = useToastMessage();
  
  // State management
  const [loading, setLoading] = useState(false);
  const [consultations, setConsultations] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedItems, setSelectedItems] = useState([]);
  const [lastVisible, setLastVisible] = useState(null);
  
  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedConsultation, setSelectedConsultation] = useState(null);
  const [answerMessage, setAnswerMessage] = useState('');
  
  // Statistics
  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    answered: 0,
    closed: 0
  });

  const statusOptions = [
    { value: 'all', label: '전체' },
    { value: 'pending', label: '대기중' },
    { value: 'answered', label: '답변완료' },
    { value: 'closed', label: '종료' },
  ];

  // Load data on component mount
  useEffect(() => {
    fetchConsultations();
    loadStatistics();
  }, [currentPage, filterStatus]);

  // Fetch consultations from Firebase
  const fetchConsultations = async () => {
    setLoading(true);
    try {
      const collectionPath = `artifacts/${appId}/consultations`;
      
      let q = query(
        collection(db, collectionPath),
        orderBy('createdAt', 'desc'),
        limit(20)
      );

      if (filterStatus !== 'all') {
        q = query(
          collection(db, collectionPath),
          where('status', '==', filterStatus),
          orderBy('createdAt', 'desc'),
          limit(20)
        );
      }

      if (currentPage > 1 && lastVisible) {
        q = query(
          collection(db, collectionPath),
          orderBy('createdAt', 'desc'),
          startAfter(lastVisible),
          limit(20)
        );
      }

      const snap = await getDocs(q);
      const consultationsData = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate?.() || new Date(),
        updatedAt: doc.data().updatedAt?.toDate?.() || new Date(),
      }));

      setConsultations(consultationsData);
      
      if (snap.docs.length > 0) {
        setLastVisible(snap.docs[snap.docs.length - 1]);
      }

      // Calculate total pages
      const countSnap = await getCountFromServer(collection(db, collectionPath));
      setTotalPages(Math.ceil(countSnap.data().count / 20));
    } catch (error) {
      console.error('Consultations loading failed:', error);
      showToastMessage('상담 신청서 로딩에 실패했습니다', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Load statistics
  const loadStatistics = async () => {
    try {
      const collectionPath = `artifacts/${appId}/consultations`;
      const allQuery = query(collection(db, collectionPath));
      const pendingQuery = query(collection(db, collectionPath), where('status', '==', 'pending'));
      const answeredQuery = query(collection(db, collectionPath), where('status', '==', 'answered'));
      const closedQuery = query(collection(db, collectionPath), where('status', '==', 'closed'));

      const [allSnap, pendingSnap, answeredSnap, closedSnap] = await Promise.all([
        getCountFromServer(allQuery),
        getCountFromServer(pendingQuery),
        getCountFromServer(answeredQuery),
        getCountFromServer(closedQuery)
      ]);

      setStats({
        total: allSnap.data().count,
        pending: pendingSnap.data().count,
        answered: answeredSnap.data().count,
        closed: closedSnap.data().count
      });
    } catch (error) {
      console.error('Statistics loading failed:', error);
    }
  };

  // Handle status update
  const handleStatusUpdate = async (consultationId, newStatus) => {
    try {
      await updateDoc(doc(db, `artifacts/${appId}/consultations`, consultationId), {
        status: newStatus,
        updatedAt: new Date(),
        reviewedBy: 'admin'
      });
      
      showToastMessage(`상담 상태가 ${newStatus}로 변경되었습니다`, 'success');
      fetchConsultations();
      loadStatistics();
    } catch (error) {
      console.error('Status update failed:', error);
      showToastMessage('상태 변경에 실패했습니다', 'error');
    }
  };

  // Handle consultation view
  const handleViewConsultation = (consultation) => {
    setSelectedConsultation(consultation);
    setIsModalOpen(true);
  };

  // Handle consultation delete
  const handleDeleteConsultation = async (consultationId) => {
    try {
      await deleteDoc(doc(db, `artifacts/${appId}/consultations`, consultationId));
      showToastMessage('상담 신청서가 삭제되었습니다', 'success');
      fetchConsultations();
      loadStatistics();
    } catch (error) {
      console.error('Delete failed:', error);
      showToastMessage('삭제에 실패했습니다', 'error');
    }
  };

  // Handle answer submission
  const handleSubmitAnswer = async () => {
    if (!answerMessage.trim() || !selectedConsultation) return;

    try {
      const consultationRef = doc(db, `artifacts/${appId}/consultations`, selectedConsultation.id);
      const answers = selectedConsultation.answers || [];
      
      await updateDoc(consultationRef, {
        answers: [...answers, {
          message: answerMessage,
          answeredBy: 'admin',
          answeredAt: new Date()
        }],
        status: 'answered',
        updatedAt: new Date()
      });

      showToastMessage('답변이 성공적으로 전송되었습니다', 'success');
      setAnswerMessage('');
      setIsModalOpen(false);
      fetchConsultations();
      loadStatistics();
    } catch (error) {
      console.error('Answer submission failed:', error);
      showToastMessage('답변 전송에 실패했습니다', 'error');
    }
  };

  // Get status color
  const getStatusColor = (status) => {
    const colors = {
      pending: 'yellow',
      answered: 'green',
      closed: 'gray'
    };
    return colors[status] || 'gray';
  };

  // Get status icon
  const getStatusIcon = (status) => {
    const icons = {
      pending: Clock,
      answered: CheckCircle,
      closed: XCircle
    };
    return icons[status] || Clock;
  };

  // Get status text
  const getStatusText = (status) => {
    switch (status) {
      case 'pending': return '대기중';
      case 'answered': return '답변완료';
      case 'closed': return '종료';
      default: return '알수없음';
    }
  };

  // Get consultation status based on answers
  const getConsultationStatus = (answers) => (answers?.length > 0 ? "답변 완료" : "미완료");
  
  const handleOpenModal = (item) => {
    setSelectedConsultation(item);
    setAnswerMessage("");
  };

  // Filter data based on search criteria
  const getFilteredData = (data) => {
    return data.filter(item => {
      const matchesSearch = !searchTerm || 
        item.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.userEmail?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.subject?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.message?.toLowerCase().includes(searchTerm.toLowerCase());
      
      return matchesSearch;
    });
  };

  // Render statistics cards
  const renderStatsCards = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-lg shadow-sm p-6"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">전체 상담</p>
            <p className="text-2xl font-bold text-gray-900">{stats.total}</p>
          </div>
          <div className="p-3 bg-blue-100 rounded-full">
            <MessageSquare className="w-6 h-6 text-blue-600" />
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="bg-white rounded-lg shadow-sm p-6"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">대기중</p>
            <p className="text-2xl font-bold text-yellow-600">{stats.pending}</p>
          </div>
          <div className="p-3 bg-yellow-100 rounded-full">
            <Clock className="w-6 h-6 text-yellow-600" />
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="bg-white rounded-lg shadow-sm p-6"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">답변완료</p>
            <p className="text-2xl font-bold text-green-600">{stats.answered}</p>
          </div>
          <div className="p-3 bg-green-100 rounded-full">
            <CheckCircle className="w-6 h-6 text-green-600" />
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="bg-white rounded-lg shadow-sm p-6"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">종료</p>
            <p className="text-2xl font-bold text-gray-600">{stats.closed}</p>
          </div>
          <div className="p-3 bg-gray-100 rounded-full">
            <XCircle className="w-6 h-6 text-gray-600" />
          </div>
        </div>
      </motion.div>
    </div>
  );

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">상담 관리</h1>
        <p className="text-gray-600">사용자 상담 신청을 관리하고 답변합니다</p>
      </div>

      {renderStatsCards()}

      {/* Main Content */}
      <div className="bg-white rounded-lg shadow-sm">
        {/* Search and Filter */}
        <div className="p-6 border-b border-gray-200">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="사용자명, 이메일, 제목으로 검색..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
            <div className="sm:w-48">
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                {statusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <button
              onClick={fetchConsultations}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center space-x-2"
            >
              <RefreshCw className="w-4 h-4" />
              <span>새로고침</span>
            </button>
          </div>
        </div>

        {/* Data Table */}
        <div className="overflow-x-auto">
          {loading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
          ) : getFilteredData(consultations).length === 0 ? (
            <div className="text-center py-12">
              <div className="text-gray-400 mb-4">
                <MessageSquare className="w-12 h-12 mx-auto" />
              </div>
              <p className="text-gray-500">상담 신청이 없습니다</p>
            </div>
          ) : (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    사용자 정보
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    제목
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    상태
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    신청일
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    액션
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {getFilteredData(consultations).map((consultation) => {
                  const StatusIcon = getStatusIcon(consultation.status);
                  return (
                    <tr key={consultation.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10">
                            <div className="h-10 w-10 rounded-full bg-gray-300 flex items-center justify-center">
                              <Users className="h-5 w-5 text-gray-600" />
                            </div>
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">
                              {consultation.userName || '이름 없음'}
                            </div>
                            <div className="text-sm text-gray-500">
                              {consultation.userEmail || '이메일 없음'}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">
                          {consultation.subject || '제목 없음'}
                        </div>
                        <div className="text-sm text-gray-500 truncate max-w-xs">
                          {consultation.message || '메시지 없음'}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-${getStatusColor(consultation.status)}-100 text-${getStatusColor(consultation.status)}-800`}>
                          <StatusIcon className="w-3 h-3 mr-1" />
                          {getStatusText(consultation.status)}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {consultation.createdAt ? new Date(consultation.createdAt).toLocaleDateString() : '-'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => handleOpenModal(consultation)}
                            className="text-blue-600 hover:text-blue-900"
                          >
                            <Eye className="w-4 h-4" />
                          </button>
                          {consultation.status === 'pending' && (
                            <button
                              onClick={() => handleStatusUpdate(consultation.id, 'answered')}
                              className="text-green-600 hover:text-green-900"
                            >
                              <CheckCircle className="w-4 h-4" />
                            </button>
                          )}
                          <button
                            onClick={() => handleDeleteConsultation(consultation.id)}
                            className="text-red-600 hover:text-red-900"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="px-6 py-4 border-t border-gray-200">
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-700">
                페이지 {currentPage} / {totalPages}
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  이전
                </button>
                <button
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  다음
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Consultation Detail Modal */}
      <AnimatePresence>
        {isModalOpen && selectedConsultation && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={() => setIsModalOpen(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                상담 상세 정보
              </h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">사용자명</label>
                  <p className="mt-1 text-sm text-gray-900">{selectedConsultation.userName || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">이메일</label>
                  <p className="mt-1 text-sm text-gray-900">{selectedConsultation.userEmail || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">제목</label>
                  <p className="mt-1 text-sm text-gray-900">{selectedConsultation.subject || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">메시지</label>
                  <p className="mt-1 text-sm text-gray-900">{selectedConsultation.message || 'N/A'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">신청일</label>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedConsultation.createdAt ? new Date(selectedConsultation.createdAt).toLocaleString() : 'N/A'}
                  </p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">상태</label>
                  <p className="mt-1 text-sm text-gray-900">{getStatusText(selectedConsultation.status)}</p>
                </div>
                
                {/* Answers */}
                {selectedConsultation.answers && selectedConsultation.answers.length > 0 && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700">답변</label>
                    <div className="mt-1 space-y-2">
                      {selectedConsultation.answers.map((answer, index) => (
                        <div key={index} className="p-3 bg-gray-50 rounded-lg">
                          <p className="text-sm text-gray-900">{answer.message}</p>
                          <p className="text-xs text-gray-500 mt-1">
                            {answer.answeredBy} - {answer.answeredAt ? new Date(answer.answeredAt).toLocaleString() : 'N/A'}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {/* Answer Form */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">답변 작성</label>
                  <textarea
                    value={answerMessage}
                    onChange={(e) => setAnswerMessage(e.target.value)}
                    rows={4}
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="답변을 입력하세요..."
                  />
                </div>
              </div>
              
              <div className="mt-6 flex justify-end space-x-2">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded hover:bg-gray-50"
                >
                  닫기
                </button>
                <button
                  onClick={handleSubmitAnswer}
                  disabled={!answerMessage.trim()}
                  className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
                >
                  <Send className="w-4 h-4" />
                  <span>답변 전송</span>
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AdminConsultationDashboard;